import './SectionHeading.css'

type SectionHeadingProps = {
  eyebrow: string
  title: string
  inverse?: boolean
  titleClassName?: string
}

export default function SectionHeading({ eyebrow, title, inverse = false, titleClassName = '' }: SectionHeadingProps) {
  return (
    <div className={`section-heading ${inverse ? 'section-heading--inverse' : ''}`}>
      <p className="section-heading__eyebrow flex items-center gap-2 text-sm font-extrabold uppercase tracking-tight">
        <span aria-hidden="true" className="section-heading__rule h-px w-8" />
        {eyebrow}
      </p>
      <h2 className={`section-heading__title mt-5 text-4xl font-extrabold leading-none tracking-tight sm:text-5xl ${titleClassName}`}>{title}</h2>
    </div>
  )
}
